module.exports = __webpack_public_path__ + "media/images/discuss_entry-126f45d6c41b3eee066a5e085bf533af.png";